import React from 'react';
import Button from '@mui/material/Button';
import useHeader from '../../constants/headerMenuList';
import { MobileContainer } from '../../services/header';
import { useLocation } from 'react-router-dom';
import AuthButton from './authButton';
import { sidebarMenu } from '../../constants/statsMenu';
import "../../index.scss";



const MobileSideBar = ({ toggleDrawer }) => {
    const { menuItems, handleNavigation } = useHeader();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleMenuItemClick = (path) => {
        handleNavigation(path);
        toggleDrawer(false);
    };

    const dashboardPaths = [
        ...sidebarMenu.map((item) => item.path),
        '/profile',
        '/healthHistory',
    ];
    const showSidebarItems = dashboardPaths.includes(currentPath);

    const isActive = (path) => currentPath === path;

    return (
        <MobileContainer
            role="presentation"
            className='mobile_side_bar'
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    toggleDrawer(false);
                }
            }}
        >
            <AuthButton className="mobile_auth_button" handleNavigation={handleNavigation} toggleDrawer={toggleDrawer} />
            {menuItems.map((item) => (
                <Button
                    key={item.id}
                    className={`mobile_menu ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick(item.path)}
                    sx={{ display: 'block' }}
                >
                    {item.label}
                </Button>
            ))}

            <div style={{ height: '1px', width: '100%', backgroundColor: '#ffffffb7' }}></div>

            {showSidebarItems && (
                <>
                    {sidebarMenu.map((item) => (
                        <Button
                            key={item.path}
                            className={`mobile_menu ${isActive(item.path) ? 'active' : ''}`}
                            onClick={() => handleMenuItemClick(item.path)}
                            sx={{ display: 'block' }}
                        >
                            {item.name}
                        </Button>
                    ))}
                </>
            )}

        </MobileContainer>
    );
};

export default MobileSideBar;
